export const buyNowFeeChartData = [
  { id: 1, name: "Electronics" },
  { id: 2, name: "Cell Phones & Accessories" },
  { id: 3, name: "Jewellery & Gemstones" },
  { id: 4, name: "Property" },
  { id: 5, name: "Home & Living" },
  { id: 6, name: "Clothing, Shoes & Accessories" },
  { id: 7, name: "Cars & Bikes" },
  { id: 8, name: "Car Parts & Accessories" },
  { id: 9, name: "Motorcycle Parts & Accessories" },
  { id: 10, name: "Boats and Watercraft" },
  { id: 11, name: "Caravans,Trucks & Buses" },
  { id: 12, name: "Truck,Trailer & Bus Spares" },
  { id: 13, name: "All Trailers" },
  { id: 14, name: "Antiques & Collectables" },
  { id: 15, name: "Coins,Notes,Stamps" },
  { id: 16, name: "Arts & Crafts" },
  { id: 17, name: "Books & Education" },
  { id: 18, name: "Music & Instruments" },
  { id: 19, name: "Holistic & Esoteric" },
  { id: 20, name: "Movies & Television" },
  { id: 21, name: "Garden, Patio & Pet Accessories" },
  { id: 22, name: "Toys & Hobbies" },
  { id: 23, name: "Sport & Leisure" },
  { id: 24, name: "Baby & Kids" },
  { id: 25, name: "Health & Beauty" },
  { id: 26, name: "Groceries & Household" },
  { id: 27, name: "Computers & Networking" },
  { id: 28, name: "Gaming" },
  { id: 29, name: "Travel & Entertainment" },
  { id: 30, name: "Live Animals" },
  { id: 31, name: "Business, Farming & Industry" },
  { id: 32, name: "Gift Vouchers & Coupons" },
];
